import React, { FunctionComponent } from 'react'
import { TableHead, TableRow, TableCell } from 'transfix-ui'
import { columns } from './columns'

export const LaneTableHeader: FunctionComponent = () => (
  <TableHead>
    <TableRow tableCellType='th'>
      {columns.map(({ cellType, label }) => (
        <TableCell key={label} type={cellType}>
          {label}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
)
